<template>
  <div>
    <div class="task-manage-info-container-dispatch" id="taskManage">
      <a-tabs class="my-tabs-dispatch" default-active-key="1" @change="onChange">
        <a-tab-pane key="1" tab="概览">
          <OverView />
        </a-tab-pane>
        <!-- <a-tab-pane key="2" tab="任务结果">
        <Result />
      </a-tab-pane> -->
        <a-tab-pane key="3" tab="任务结果"></a-tab-pane>
      </a-tabs>
    </div>
    <div v-if="showTag && spiderClassType === 'document'">
      <div v-if="cardData && cardData.length > 0">
        <div v-for="(items, index) in cardData" :key="index">
          <transition>
            <ProjectListDoc :data="items" />
          </transition>
        </div>
      </div>
      <div v-else>
        <a-empty />
      </div>
    </div>
    <div v-if="showTag && spiderClassType != 'document'">
      <div v-if="cardData && cardData.length > 0">
        <div v-for="(items, index) in cardData" :key="index">
          <transition>
            <ProjectListNews :data="items" />
          </transition>
        </div>
      </div>
      <div v-else>
        <a-empty />

        
<!-- <template>
  <a-pagination v-model="current" :total="50" show-less-items @change='changePage('document')'/>
// </template> -->

      </div>
    </div>
    <div
      v-if="
        showTag &&
        (spiderClassType === 'twitter' ||
          spiderClassType === 'weibo' ||
          spiderClassType === 'facebook' ||
          spiderClassType === 'youtube')
      "
    >
      <div v-if="cardData && cardData.length > 0">
        <div v-for="(items, index) in cardData" :key="index">
          <transition>
            <ProjectListTwItter :data="items" />
          </transition>
        </div>
      </div>
      <div v-else>
        <a-empty />
      </div>
    </div>
    <a-button
      size="large"
      class="btn"
      style="float: right; right: 15px; width: 100px"
      type="primary"
      @click="back()"
      >返回</a-button
    >
  </div>
</template>

<script>
import OverView from './OverView'
import Result from './Result'
import ProjectListDoc from './ProjectListDoc.vue'
import ProjectListNews from './ProjectListNews.vue'
import ProjectListTwItter from './ProjectListTwItter.vue'
import { querySpiderResultsApi, queryScheduleRecordInfoApi } from '@/api/Dispatch/TaskManage'
export default {
  data() {
    return {
      showTag: false,
      cardData: [],
      spiderClassType: 'news',
      current:2
    }
  },
  components: {
    OverView,
    Result,
    ProjectListDoc,
    ProjectListNews,
    ProjectListTwItter
  },
  created() {
    let { taskId, spiderId } = this.$route.query
  
    if (taskId) {
      this.queryScheduleRecordInfo(taskId,spiderId)
    }
    this.handleSearch()
  },
  methods: {
    back() {
      sessionStorage.refresh = 'close'
      this.$router.back(-1)
    },
    async queryScheduleRecordInfo(taskId, spiderId) {
      this.loading = true
      let res = await queryScheduleRecordInfoApi({ taskId, spiderId, parseFailedWebStatus: 1 })
      this.loading = false
      let { code, msg, extra } = res
      if (code == '200') {
        this.task = extra.task
        this.spiderClassType = extra.task.spiderClassType
      } else {
        this.$message.error(msg)
      }
    },
    onChange(activeKey) {
      // 当切换到任务日志时，强制滚动一下
      // 因为做了虚拟滚动的原因
      if (activeKey == 3) {
        this.showTag = true
        // this.$nextTick(() => {
        //   this.$refs.TaskLog.forceWheel()
        // })
      } else {
        this.showTag = false
      }
    },
    handleSearch() {
      let { taskId } = this.$route.query
      if (taskId) {
        this.querySpiderResults(taskId)
      }
    },
    async querySpiderResults(taskId) {
      let query = { taskId }
      let res = await querySpiderResultsApi(query)
      this.cardData = res.data
    }
  }
}
</script>
<style lang="less" scoped>
.task-manage-info-container-dispatch {
  padding: 16px;
  width: 100%;

  .my-tabs-dispatch {
    background-color: white;
    padding: 0 16px;
  }
}
</style>

<style scoped>
#taskManage /deep/ .ant-tabs-bar {
  margin: 0 0 0 0;
}
</style>
